import Mock from "mockjs";
import { isSSR } from "@/utils/is";
import setupMock from "@/utils/setupMock";

const getMockAuthorities = (role: string) => {
  if (role === "admin") {
    return [
      "sys:user:list",
      "sys:user:add",
      "sys:user:edit",
      "sys:user:delete",
      "sys:user:import",
      "sys:user:export",
      "sys:menu:list",
      "sys:role:list",
      "sys:loginlog:list",
      "sys:operlog:list",
      "sys:config:list",
      "drm:account:add",
      "drm:account:edit",
      "drm:account:delete",
    ];
  }
  return ["sys:user:list"];
};

const mockMenus = [
  {
    title: "仪表盘",
    path: "/dashboard",
    children: [
      {
        title: "工作台",
        path: "/dashboard/workplace",
        component: "dashboard/workplace",
      },
    ],
  },
  {
    title: "CDK 管理",
    path: "/cdk",
    children: [
      {
        title: "CDK 列表",
        path: "/cdk/index",
        component: "cdk/index",
      },
      {
        title: "回收日志",
        path: "/cdk/recycle-log",
        component: "cdk/recycle-log",
      },
      {
        title: "请求日志",
        path: "/cdk/access-log",
        component: "cdk/access-log",
      },
      {
        title: "盒子激活管理",
        path: "/box/index",
        component: "box/index",
      },
    ],
  },
  {
    title: "游戏管理",
    path: "/game",
    children: [
      {
        title: "游戏列表",
        path: "/game/index",
        component: "game/index",
      },
      {
        title: "盒子上架管理",
        path: "/game/box",
        component: "game/box",
      },
    ],
  },
  {
    title: "账号管理",
    path: "/account",
    children: [
      {
        title: "D加密账号",
        path: "/account/drm",
        component: "account/drm",
      },
    ],
  },
  {
    title: "Steam 管理",
    path: "/steam",
    children: [
      {
        title: "激活用户",
        path: "/steam/info",
        component: "steam/info",
      },
    ],
  },
  {
    title: "会员管理",
    path: "/member",
    children: [
      {
        title: "会员列表",
        path: "/member/index",
        component: "member/index",
      },
      {
        title: "会员积分",
        path: "/member/points",
        component: "member/points",
      },
      {
        title: "游戏购买",
        path: "/member/purchase",
        component: "member/purchase",
      },
      {
        title: "充值日志",
        path: "/admin/recharge/record",
        component: "admin/recharge/record",
      },
      {
        title: "许愿列表",
        path: "/member/wish",
        component: "member/wish",
        icon: "el-icon-aim",
      },
    ],
  },
  {
    title: "系统管理",
    path: "/system",
    icon: "el-icon-setting",
    children: [
      {
        title: "用户管理",
        path: "/system/user-management",
        component: "system/user-management",
        icon: "el-icon-user",
      },
      {
        title: "菜单管理",
        path: "/system/menu-management",
        component: "system/menu-management",
        icon: "el-icon-menu",
      },
      {
        title: "角色管理",
        path: "/system/role",
        component: "system/role",
        icon: "el-icon-s-custom",
      },
      {
        title: "禁用游戏列表",
        path: "/system/banned-games",
        component: "system/banned-games",
        icon: "el-icon-remove",
      },
      {
        title: "登录日志",
        path: "/system/loginlog",
        component: "system/loginlog",
        icon: "el-icon-time",
      },
      {
        title: "操作日志",
        path: "/system/operlog",
        component: "system/operlog",
        icon: "el-icon-document",
      },
    ],
  },
  {
    title: "系统配置",
    path: "/config",
    children: [
      {
        title: "站点配置",
        path: "/config/website",
        component: "config/website",
      },
    ],
  },
  {
    title: "个人中心",
    path: "/user",
    children: [
      {
        title: "个人信息",
        path: "/user/profile",
        component: "user/profile",
      },
    ],
  },
];

if (!isSSR) {
  Mock.XHR.prototype.withCredentials = true;

  setupMock({
    setup: () => {
      const userRole = window.localStorage.getItem("userRole") || "admin";
      Mock.mock(new RegExp("/api/user/userInfo"), () => {
        const authorities = getMockAuthorities(userRole);
        return Mock.mock({
          name: "admin",
          avatar:
            "https://lf1-xgcdn-tos.pstatp.com/obj/vcloud/vadmin/start.8e0e4855ee346a46ccff8ff3e24db27b.png",
          email: "wangliqun@email.com",
          job: "frontend",
          jobName: "前端开发工程师",
          organization: "Frontend",
          organizationName: "前端",
          location: "beijing",
          locationName: "北京",
          introduction: "王力群并非是一个真实存在的人。",
          personalWebsite: "https://www.arco.design",
          verified: true,
          phoneNumber: /177[*]{6}[0-9]{2}/,
          accountId: /[a-z]{4}[-][0-9]{8}/,
          registrationTime: Mock.Random.datetime("yyyy-MM-dd HH:mm:ss"),
          authorities,
        });
      });

      Mock.mock(new RegExp("/menu/getList"), () => mockMenus);

      Mock.mock(new RegExp("/account/drm/list"), () => {
        return Mock.mock({
          code: 200,
          data: {
            list: [
              {
                id: 1,
                gameId: 1091500,
                gameName: "Cyberpunk 2077",
                username: "steam_user_01",
                password: "Cyb3rpunk!77",
                refreshToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
                usageCount: 128,
                windowStart: "2026-07-10 08:00:00",
                failedCount: 0,
                lastFailedReason: null,
                lastFailedAt: null,
                status: 1,
                description: "主力Steam账号",
                createdBy: 1,
                createdAt: "2025-01-15 10:00:00",
                updatedBy: 1,
                updatedAt: "2026-07-11 09:30:00",
              },
              {
                id: 2,
                gameId: 1245620,
                gameName: "Elden Ring",
                username: "steam_user_02",
                password: "EldenRing!23",
                refreshToken: "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9...",
                usageCount: 67,
                windowStart: "2026-07-09 14:00:00",
                failedCount: 2,
                lastFailedReason: "登录凭证过期",
                lastFailedAt: "2026-07-08 03:15:00",
                status: 1,
                description: "备用账号",
                createdBy: 1,
                createdAt: "2025-03-20 14:30:00",
                updatedBy: 2,
                updatedAt: "2026-07-10 11:00:00",
              },
              {
                id: 3,
                gameId: 1174180,
                gameName: "Red Dead Redemption 2",
                username: "steam_user_03",
                password: "RDR2!P@ss456",
                refreshToken: null,
                usageCount: 0,
                windowStart: null,
                failedCount: 5,
                lastFailedReason: "账号被临时锁定",
                lastFailedAt: "2026-06-28 22:30:00",
                status: 0,
                description: "已被锁定",
                created_by: 2,
                created_at: "2024-11-01 08:00:00",
                updated_by: 1,
                updated_at: "2026-06-28 22:30:00",
              },
            ],
            total: 3,
          },
        });
      });

      Mock.mock(new RegExp("/account/drm/add"), () => {
        return { code: 200, message: "创建成功" };
      });

      Mock.mock(new RegExp("/account/drm/update"), () => {
        return { code: 200, message: "更新成功" };
      });

      Mock.mock(new RegExp("/account/drm/delete"), () => {
        return { code: 200, message: "删除成功" };
      });

      Mock.mock(new RegExp("/member/list"), () => {
        return Mock.mock({
          code: 200,
          data: {
            list: [
              {
                id: 1,
                username: "alice",
                nickname: "爱丽丝",
                phone: "13800000001",
                mail: "alice@example.com",
                steamId: "76561198000000001",
                invitationCode: "INV-0001",
                status: 1,
                gender: 2,
                city: "上海",
                integration: 1200,
                growth: 580,
                luckeyCount: 3,
                createdAt: "2025-01-15 10:00:00",
              },
              {
                id: 2,
                username: "bob",
                nickname: "鲍勃",
                phone: "13800000002",
                mail: "bob@example.com",
                steamId: "76561198000000002",
                invitationCode: "INV-0002",
                status: 1,
                gender: 1,
                city: "北京",
                integration: 860,
                growth: 320,
                luckeyCount: 1,
                createdAt: "2025-03-20 14:30:00",
              },
              {
                id: 3,
                username: "carol",
                nickname: "卡罗尔",
                phone: "13800000003",
                mail: "carol@example.com",
                steamId: "76561198000000003",
                invitationCode: "INV-0003",
                status: 0,
                gender: 0,
                city: "广州",
                integration: 0,
                growth: 0,
                luckeyCount: 0,
                createdAt: "2024-11-01 08:00:00",
              },
            ],
            total: 3,
          },
        });
      });

      Mock.mock(new RegExp("/member/updateStatus"), () => {
        return { code: 200, message: "状态更新成功" };
      });

      Mock.mock(new RegExp("/member/update"), () => {
        return { code: 200, message: "更新成功" };
      });

      Mock.mock(new RegExp("/member/points/adjust"), () => {
        return { code: 200, message: "积分调整成功" };
      });

      Mock.mock(new RegExp("/member/points/account/list"), () => {
        return Mock.mock({
          code: 200,
          data: {
            records: [
              {
                id: 1,
                memberId: 1,
                memberUsername: "alice",
                memberNickname: "爱丽丝",
                balance: 1200,
                totalEarned: 5000,
                totalSpent: 3800,
                createTime: "2025-01-15 10:00:00",
                updateTime: "2026-09-14 09:00:00",
              },
              {
                id: 2,
                memberId: 2,
                memberUsername: "bob",
                memberNickname: "鲍勃",
                balance: 860,
                totalEarned: 2000,
                totalSpent: 1140,
                createTime: "2025-03-20 14:30:00",
                updateTime: "2026-09-14 09:30:00",
              },
              {
                id: 3,
                memberId: 3,
                memberUsername: "carol",
                memberNickname: "卡罗尔",
                balance: 0,
                totalEarned: 500,
                totalSpent: 500,
                createTime: "2024-11-01 08:00:00",
                updateTime: "2026-09-14 10:00:00",
              },
            ],
            total: 3,
          },
        });
      });

      Mock.mock(new RegExp("/member/points/record/list"), () => {
        return Mock.mock({
          code: 200,
          data: {
            records: [
              {
                id: 1,
                memberId: 1,
                memberUsername: "alice",
                memberNickname: "爱丽丝",
                type: 2,
                changeAmount: -1200,
                balanceAfter: 1200,
                remark: "兑换游戏 Cyberpunk 2077",
                createTime: "2026-09-14 09:00:00",
              },
              {
                id: 2,
                memberId: 1,
                memberUsername: "alice",
                memberNickname: "爱丽丝",
                type: 1,
                changeAmount: 100,
                balanceAfter: 2400,
                remark: "每日签到",
                createTime: "2026-09-13 08:00:00",
              },
              {
                id: 3,
                memberId: 2,
                memberUsername: "bob",
                memberNickname: "鲍勃",
                type: 3,
                changeAmount: 500,
                balanceAfter: 860,
                remark: "后台调整",
                createTime: "2026-09-12 10:30:00",
              },
            ],
            total: 3,
          },
        });
      });

      Mock.mock(new RegExp("/member/purchase/list"), () => {
        return Mock.mock({
          code: 200,
          data: {
            records: [
              {
                id: 1,
                memberId: 1,
                memberUsername: "alice",
                memberNickname: "爱丽丝",
                gameId: "1091500",
                gameName: "Cyberpunk 2077",
                type: 0,
                cost: 1200,
                pointsCost: 1200,
                steamId: "76561198000000001",
                status: 1,
                createTime: "2026-09-14 09:00:00",
                updateTime: "2026-09-14 09:00:00",
              },
              {
                id: 2,
                memberId: 2,
                memberUsername: "bob",
                memberNickname: "鲍勃",
                gameId: "1245620",
                gameName: "Elden Ring",
                type: 1,
                cost: 199,
                pointsCost: 800,
                steamId: "76561198000000002",
                status: 1,
                createTime: "2026-09-10 14:30:00",
                updateTime: "2026-09-10 14:30:00",
              },
              {
                id: 3,
                memberId: 3,
                memberUsername: "carol",
                memberNickname: "卡罗尔",
                gameId: "1174180",
                gameName: "Red Dead Redemption 2",
                type: 0,
                cost: 500,
                pointsCost: 500,
                steamId: "76561198000000003",
                status: 2,
                createTime: "2026-08-01 08:00:00",
                updateTime: "2026-08-02 08:00:00",
              },
            ],
            total: 3,
          },
        });
      });

      Mock.mock(new RegExp("/asset/recharge/log/list"), () => {
        return Mock.mock({
          code: 200,
          data: {
            records: [
              {
                id: 1,
                orderNo: "RC2026091400001",
                memberId: 1,
                memberUsername: "alice",
                memberNickname: "爱丽丝",
                type: 1,
                amount: 100,
                balanceAfter: 1200,
                status: 1,
                remark: "在线支付",
                createdByName: "system",
                createdAt: "2026-09-14 09:00:00",
              },
              {
                id: 2,
                orderNo: "RC2026091200001",
                memberId: 2,
                memberUsername: "bob",
                memberNickname: "鲍勃",
                type: 3,
                amount: 50,
                balanceAfter: 860,
                status: 1,
                remark: "卡密充值",
                createdByName: "system",
                createdAt: "2026-09-12 10:30:00",
              },
              {
                id: 3,
                orderNo: "RC2026090100001",
                memberId: 3,
                memberUsername: "carol",
                memberNickname: "卡罗尔",
                type: 2,
                amount: 200,
                balanceAfter: 500,
                status: 0,
                remark: "后台充值",
                createdByName: "admin",
                createdAt: "2026-09-01 08:00:00",
              },
            ],
            total: 3,
          },
        });
      });

      Mock.mock(new RegExp("/api/user/login"), (params) => {
        const { userName, password } = JSON.parse(params.body);
        if (!userName) {
          return {
            status: "error",
            msg: "用户名不能为空",
          };
        }
        if (!password) {
          return {
            status: "error",
            msg: "密码不能为空",
          };
        }
        if (userName === "admin" && password === "admin") {
          return {
            status: "ok",
          };
        }
        return {
          status: "error",
          msg: "账号或者密码错误",
        };
      });
    },
  });
}
